import { ReactNode } from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { MeshConfig, MeshGradient } from './MeshGradient';
import { TypeChip } from '../Nugget/TypeChip';

export type NuggetGradientFallbackProps = Readonly<{
  entityName: string;
  badge: ReactNode;
  featuredIcon?: ReactNode;
  hoverButton?: ReactNode;
  description?: string;
  meshConfig?: MeshConfig;
}>;

export const NuggetGradientFallback = ({
  entityName,
  badge,
  featuredIcon,
  hoverButton,
  description,
  meshConfig,
}: NuggetGradientFallbackProps) => {
  const isDescriptionVariant = !!description;

  return (
    <Box sx={isDescriptionVariant ? descriptionContainerSx : gradientContainerSx}>
      {!isDescriptionVariant && meshConfig && <MeshGradient config={meshConfig} />}
      {featuredIcon && <Box sx={featuredIconPositionSx}>{featuredIcon}</Box>}
      {hoverButton}
      {isDescriptionVariant ? (
        <Typography variant="text-xs-medium" sx={descriptionTextSx}>
          {description}
        </Typography>
      ) : (
        <Box sx={entityNameChipSx(!!featuredIcon)}>
          <TypeChip label={entityName} />
        </Box>
      )}
      <Box sx={badgePositionSx}>{badge}</Box>
    </Box>
  );
};

const gradientContainerSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: backrs.colors['Beige/50'],
});

const descriptionContainerSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: backrs.colors['Beige/100'],
  position: 'relative',
  overflow: 'hidden',
});

const featuredIconPositionSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  top: backrs.spacing['spacing-xl'],
  left: backrs.spacing['spacing-xl'],
  zIndex: 1,
});

const descriptionTextSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  top: 87,
  left: backrs.spacing['spacing-lg'],
  width: 268,
  color: backrs.colors['Gray/900'],
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const entityNameChipSx =
  (hasFeaturedIcon: boolean): SxProps<Theme> =>
  () => ({
    position: 'absolute',
    top: 16,
    left: hasFeaturedIcon ? 64 : 16,
    maxWidth: hasFeaturedIcon ? 200 : 248,
  });

const badgePositionSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  bottom: backrs.spacing['spacing-lg'],
  left: backrs.spacing['spacing-lg'],
});
